// extracted by mini-css-extract-plugin
module.exports = {"FlexContainer":"FlexContainer_FlexContainer__3dkKa"};